import { Component } from 'react';

import Box from '@mui/material/Box';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { flowRight as compose } from 'lodash';

import AxlButton from 'AxlMUIComponent/AxlButton';
import AxlInput from 'AxlMUIComponent/AxlInput';
import styles from './styles';
class ShipmentCustomerForm extends Component {
  save = (e) => {
    const { shipment, closeForm } = this.props;
    const { shipmentStore } = this.props.store;
    shipmentStore.updateShipmentCustomer(shipment, () => {
      closeForm();
    });
  };

  render() {
    const { shipment, dropoff } = this.props;
    const { shipmentStore } = this.props.store;
    const { shipmentCustomerForm } = shipmentStore;

    const { customer } = shipment;

    return (
      <div style={styles.Container}>
        <div style={styles.HeaderTitle}>{`Edit Customer`}</div>
        <Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1, ...styles.GroupPanel }}>
              <div style={styles.GroupField}>
                <div style={styles.Field}>
                  <AxlInput
                    value={shipmentCustomerForm.getField('name', '')}
                    onChange={shipmentCustomerForm.handlerInput}
                    placeholder={`Name`}
                    name={`name`}
                    type={`text`}
                    fluid
                  />
                </div>
                <div style={styles.Field}>
                  <AxlInput
                    value={shipmentCustomerForm.getField('email', '')}
                    onChange={shipmentCustomerForm.handlerInput}
                    placeholder={`Email Address`}
                    name={`email`}
                    type={`email`}
                    fluid
                  />
                </div>
                <div style={styles.Field}>
                  <AxlInput
                    value={shipmentCustomerForm.getField('phone_number', '')}
                    onChange={shipmentCustomerForm.handlerInput}
                    placeholder={`Phone Number`}
                    name={`phone_number`}
                    type={`text`}
                    fluid
                  />
                </div>
              </div>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1 }}></Box>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
                <div style={{ ...styles.Field, ...styles.FieldButton }}>
                  <AxlButton compact bg={`gray`} onClick={this.props.closeForm} style={styles.buttonControl}>{`Cancel`}</AxlButton>
                </div>
                <div style={{ ...styles.Field, ...styles.FieldButton }}>
                  <AxlButton compact bg={`pink`} onClick={this.save} style={styles.buttonControl}>{`Save`}</AxlButton>
                </div>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
}
export default compose(withRouter, inject('store'), observer)(ShipmentCustomerForm);
